import { configureStore } from '@reduxjs/toolkit';
import persistedReducer from '../reducers';

const store = configureStore({
  reducer: persistedReducer,
});

export default store;
